import TasksAPI from '../../api/tasks';

export const SET_TASKS_UI_FLAG = 'SET_TASKS_UI_FLAG';
export const SET_CONVERSATION_TASKS = 'SET_CONVERSATION_TASKS';
export const UPDATE_CONVERSATION_TASK = 'UPDATE_CONVERSATION_TASK';
export const REMOVE_CONVERSATION_TASK = 'REMOVE_CONVERSATION_TASK';
export const SET_ACCOUNT_TASKS = 'SET_ACCOUNT_TASKS';
export const REPLACE_ACCOUNT_TASK = 'REPLACE_ACCOUNT_TASK';
export const REMOVE_ACCOUNT_TASK = 'REMOVE_ACCOUNT_TASK';

export const state = {
  records: {},
  accountRecords: [],
  accountMeta: { currentPage: 1, totalPages: 1, totalCount: 0 },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingAll: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getForConversation: $state => conversationId => {
    return $state.records[conversationId] || [];
  },
  getAccountTasks(_state) {
    return _state.accountRecords;
  },
  getAccountMeta(_state) {
    return _state.accountMeta;
  },
};

export const actions = {
  get: async ({ commit }, conversationId) => {
    commit(SET_TASKS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await TasksAPI.getForConversation(conversationId);
      commit(SET_CONVERSATION_TASKS, { conversationId, data });
    } catch (error) {
      // Ignore error
    } finally {
      commit(SET_TASKS_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, params) => {
    commit(SET_TASKS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await TasksAPI.createForConversation(params);
      commit(SET_CONVERSATION_TASKS, {
        conversationId: params.conversationId,
        data: undefined,
        appendRecord: data,
      });
      return data;
    } finally {
      commit(SET_TASKS_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, params) => {
    commit(SET_TASKS_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await TasksAPI.updateForConversation(params);
      commit(UPDATE_CONVERSATION_TASK, {
        conversationId: params.conversationId,
        record: data,
      });
      return data;
    } finally {
      commit(SET_TASKS_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, { conversationId, id }) => {
    commit(SET_TASKS_UI_FLAG, { isDeleting: true });
    try {
      await TasksAPI.deleteForConversation({ conversationId, id });
      commit(REMOVE_CONVERSATION_TASK, { conversationId, id });
    } finally {
      commit(SET_TASKS_UI_FLAG, { isDeleting: false });
    }
  },

  getAll: async ({ commit }, params = {}) => {
    commit(SET_TASKS_UI_FLAG, { isFetchingAll: true });
    try {
      const { data } = await TasksAPI.getAll(params);
      commit(SET_ACCOUNT_TASKS, data);
    } finally {
      commit(SET_TASKS_UI_FLAG, { isFetchingAll: false });
    }
  },

  updateAccountWide: async ({ commit }, { id, ...changes }) => {
    commit(SET_TASKS_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await TasksAPI.update(id, { task: changes });
      commit(REPLACE_ACCOUNT_TASK, data);
      return data;
    } finally {
      commit(SET_TASKS_UI_FLAG, { isUpdating: false });
    }
  },

  deleteAccountWide: async ({ commit }, id) => {
    commit(SET_TASKS_UI_FLAG, { isDeleting: true });
    try {
      await TasksAPI.delete(id);
      commit(REMOVE_ACCOUNT_TASK, id);
    } finally {
      commit(SET_TASKS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [SET_TASKS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  [SET_CONVERSATION_TASKS]($state, { conversationId, data, appendRecord }) {
    const existing = $state.records[conversationId] || [];
    const nextRecords = appendRecord ? [...existing, appendRecord] : data;
    $state.records = { ...$state.records, [conversationId]: nextRecords };
  },

  [UPDATE_CONVERSATION_TASK]($state, { conversationId, record }) {
    const existing = $state.records[conversationId] || [];
    $state.records = {
      ...$state.records,
      [conversationId]: existing.map(task =>
        task.id === record.id ? record : task
      ),
    };
  },

  [REMOVE_CONVERSATION_TASK]($state, { conversationId, id }) {
    const existing = $state.records[conversationId] || [];
    $state.records = {
      ...$state.records,
      [conversationId]: existing.filter(record => record.id !== id),
    };
  },

  [SET_ACCOUNT_TASKS]($state, { payload, meta }) {
    $state.accountRecords = payload;
    $state.accountMeta = {
      currentPage: meta.current_page,
      totalPages: meta.total_pages,
      totalCount: meta.total_count,
    };
  },

  [REPLACE_ACCOUNT_TASK]($state, record) {
    $state.accountRecords = $state.accountRecords.map(task =>
      task.id === record.id ? record : task
    );
  },

  [REMOVE_ACCOUNT_TASK]($state, id) {
    $state.accountRecords = $state.accountRecords.filter(
      record => record.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
